export const getPortalAbbr = () => window.location.pathname.split('/')[1] || ''
